import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
};

export const ScheduleCreatePage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      {
        label: "スケジュール",
        path: `/sites/${siteSlug}/settings?tab=schedules`,
      },
      { label: "スケジュール登録", path: `/sites/${siteSlug}/schedules/new` },
    ],
    [siteSlug]
  );
  return (
    <PageLayout title="スケジュール登録" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
